export default "__VITE_ASSET__CEekSu7r__"